import { IRoles } from 'types/roles';
import api from '../services/config/api';

export const getRolesList = () => api.get<IRoles[]>('/group-role/{id}?ids=1');

interface IRolesUser {
  id: number;
  roles: Array<{ id: number; name: string; description: string }>;
}

export const getRolesUser = async (idUser: string) => {
  const response = await api.get<IRolesUser>(`/user/${idUser}`);
  return response;
};
